export default __webpack_public_path__ + "static/real-grad-left-449744ef9c9b3c3b6817fcb40d00323b.svg";